module.exports = __webpack_public_path__ + "img/file-video.83955e3d.svg";